import React from 'react'

import Layout from '../pages/layout'

import Header from '../components/layout/SwaggerAPI/Header.js'
import Resources from '../components/layout/SwaggerAPI/Resources.js'
import Definitions from '../components/layout/SwaggerAPI/Definitions.js'
import Errors from '../components/layout/SwaggerAPI/Errors.js'

const TemplateLayout = (props) => {
  const post = props.pageContext.post
  const merged_pages = props.pageContext.min_merged_pages
  const isDeprecated = post.x_deprecated ? true : false

  return (
    <Layout
      layout="dx-apiref dx-apis"
      location={props.location}
      leftNav={merged_pages}
      leftNavBar="true"
      isDeprecated={isDeprecated}
      apiLatestVersion={post.latestVersion}
      apiLatestVersionPath={post.latestVersionPath}
      title={post.info.title}
      fileAbsolutePath={props.location.pathname}
    >
      <div id="hashLinkContainer" />
      <article className="content dx-content dx-content-api">
        <div className="dax-api " id={post.info.x_id}>
          <Header
            currentVersion={post._borg_metadata.version}
            versions={post.versions}
            title={post.info.title}
            description={post.info.description}
            location={props.location}
          />
          <Resources resources={post.tags} />
          <Definitions definitions={post.definitions} />
          <Errors
            x_errors={post.x_errors}
            x_errors_2={post.x_errors_2}
            title={post.info.title}
          />
        </div>
      </article>
    </Layout>
  )
}

export default TemplateLayout
